const SentMailTableConfig = [
  {
    field: 'mailType',
    label: 'Typ wiadomości',
    sort: 'asc',
    type: 'enum',
    enumType: 'enums/mailType',
    width: 150,
  },
  {
    field: 'toEmail',
    label: 'Odbiorca',
    sort: 'asc',
    type: "badge",
    badgeType: "light",
    width: 200,
  },
  {
    field: 'subject',
    label: 'Temat',
    sort: 'asc',
    width: 250,
    type: 'textarea'
  },
  {
    field: 'sentAt',
    label: 'Data wysłania',
    sort: 'asc',
    width: 150,
  },
  {
    field: 'status',
    label: 'Status',
    sort: 'asc',
    type: 'enum',
    enumType: 'enums/mailStatus',
    width: 150,
  }
];

export default SentMailTableConfig;